import { BaseService } from '../base/base.service';
import { AppService } from '../main/app.service';

export class IDashboard {
    id: string;
    accountId: string;
    firstName: string;
    middleName: string;
    lastName: string;
}

export class DashboardService extends BaseService<IDashboard> {
    constructor(Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'dashboard');
    }
}


// WEBPACK FOOTER //
// ./src/app/services/dashboard.service.ts